import { NodeEntry, Range } from 'slate';
import { CustomEditor } from 'slate/types/slate';

type Decorate = (entry: NodeEntry) => Range[];

export function composeDecorators(editor: CustomEditor, ...decoratorFactories: Array<(editor: CustomEditor) => Decorate>) {
  const decorators = decoratorFactories.map((factory) => factory(editor));
  return (entry: NodeEntry): Range[] => {
    return decorators.flatMap((decorator) => {
      if (typeof decorator === 'function') {
        return decorator(entry) || [];
      }
      return [];
    });
  };
}
